import React from 'react';
import styled from 'styled-components';
import { Box } from '@solvhealth/jigsaw-v1';
import { ImageObject } from '@solvhealth/types/interfaces/ImageObject';
import { colors } from '~/constants/colors';
import Picture from '~/components/SolvPatternLibrary/Picture';

const Root = styled(Box).withConfig({ componentId: 'sc-1movtal-0' })`
  .logo-container {
    width: 100%;
  }
`;

export type LogoProps = {
  imageObject: ImageObject;
  altText: string;
  metaTags?: JSX.Element;
};

const Logo = (props: LogoProps) => {
  return (
    <Root
      alignItems="center"
      alignSelf="center"
      backgroundColor="white"
      border={`solid 2px ${colors.greyCorona}`}
      borderRadius="base"
      display="flex"
      height={{ _: '104px', md: '132px' }}
      justifyContent="center"
      minWidth={{ _: '104px', md: '132px' }}
      ml={{ md: 'auto' }}
      padding={1.5}
      sx={{
        boxSizing: 'border-box',
      }}
      // Disallow this image from being resized inside a flex container
      width={{ _: '104px', md: '132px' }}
      zIndex={1}
    >
      {props.metaTags}
      <Picture
        alt={props.altText}
        className="logo-container"
        imageObject={props.imageObject}
        role="presentation"
        width="100%"
      />
    </Root>
  );
};

export default Logo;
